document.addEventListener('DOMContentLoaded', () => {
  const forms = Array.from(document.querySelectorAll('.js-return-request-form'));

  /**
   *
   * @param {boolean} show - show
   * @param {HTMLDivElement} container - container
   */
  function toggleForm(show, container) {
    const el = container;

    if (show && el) {
      el.classList.add('is-active');
    } else {
      el.classList.remove('is-active');
    }
  }

  /**
   *
   * @param {HTMLFormElement} form - Form
   * @param item
   */
  function handleItem(item) {
    const checkboxContainer = item.querySelector('.js-return-request-form-checkbox');

    if (checkboxContainer.querySelector('input')) {
      toggleForm(checkboxContainer.querySelector('input').checked, item);

      checkboxContainer.querySelector('input').addEventListener('change', () => {
        toggleForm(checkboxContainer.querySelector('input').checked, item);
      });
    }
  }

  forms.forEach((form) => {
    const ordersEl = form.querySelector('.js-return-request-form-orders');

    if (ordersEl) {
      const items = ordersEl.querySelectorAll('.js-return-request-form-order');

      items.forEach((item) => handleItem(item));
    }
  });
});
